import { LogLevel } from '@azure/msal-browser';

export const msalConfig = {
  auth: {
    // CORRECTED: CIAM Client ID (from your working test link)
    clientId: '89f7267e-7563-4ffd-98f4-7f275dca84ce',
    // CORRECTED: CIAM authority (ciamlogin.com, NOT b2clogin.com)
    authority: 'https://driftalarmext.ciamlogin.com/driftalarmext.onmicrosoft.com',
    // CORRECTED: CIAM domain
    knownAuthorities: ['driftalarmext.ciamlogin.com'],
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Info:
            console.info(message);
            return;
          case LogLevel.Verbose:
            console.debug(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
          default:
            return;
        }
      },
    },
  },
};

// CORRECTED: CIAM scopes (openid, profile, email - NOT custom API scope)
export const loginRequest = {
  scopes: ['openid', 'profile', 'email'],
};

export const tokenRequest = {
  scopes: ['openid', 'profile', 'email'],
};